import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home'
import Login from '@/views/Login'
// import ToBeDone from '@/views/TBD'
import Config from '@/views/Config'
import EventOverview from '@/views/Event/Overview'
import UserOverview from '@/views/User/Overview'
import UserDetail from '@/views/User/Detail'
import CountryOverview from '@/views/Country/Overview'
import CountryDetail from '@/views/Country/Detail'
import UniversityOverview from '@/views/University/Overview'
import UniversityDetail from '@/views/University/Detail'
import ProgramOverview from '@/views/Program/Overview'
import ProgramDetail from '@/views/Program/Detail'
import StudentFeeOverview from '@/views/StudentFee/Overview'
import StudentFeeDetail from '@/views/StudentFee/Detail'
import MilestoneOverview from '@/views/Milestone/Overview'
import MilestoneDetail from '@/views/Milestone/Detail'
import StudentOverview from '@/views/Student/Overview'
import StudentDetail from '@/views/Student/Detail'
import ContractOverview from '@/views/Contract/Overview'
import ContractDetail from '@/views/Contract/Detail'
import InvoiceOverview from '@/views/Invoice/Overview'
import InvoiceDetail from '@/views/Invoice/Detail'
import InvoicPaymentOverview from '@/views/InvoicePayment/Overview'
import InvoicePaymentDetail from '@/views/InvoicePayment/Detail'
import ScholarshipPaymentOverview from '@/views/ScholarshipPayment/Overview'
import ScholarshipPaymentDetail from '@/views/ScholarshipPayment/Detail'

// const privDeveloper = {auth: 'Developer'}
const privAdministrator = {auth: ['Developer', 'Administrator']}
// const privUser = {auth: ['Developer', 'Administrator', 'User']}
// const privReader = {auth: ['Developer', 'Administrator', 'User', 'Reader']}
Vue.use(Router)
export default new Router({
  routes: [
    {path: '/', name: 'home', component: Home},
    // {path: '/tbd', name: 'tbd', component: ToBeDone},
    {path: '/login', name: 'login', meta: {auth: false}, component: Login},
    {path: '/config', name: 'config', meta: privAdministrator, component: Config},
    {path: '/events', name: 'events', meta: {auth: true}, component: EventOverview},
    {path: '/users', name: 'users', meta: {auth: true}, component: UserOverview},
    {path: '/user/:id', name: 'user', meta: {auth: true}, component: UserDetail},
    {path: '/countries', name: 'countries', meta: {auth: true}, component: CountryOverview},
    {path: '/country/:id', name: 'country', meta: {auth: true}, component: CountryDetail},
    {path: '/universities', name: 'universities', meta: {auth: true}, component: UniversityOverview},
    {path: '/university/:id', name: 'university', meta: {auth: true}, component: UniversityDetail},
    {path: '/programs', name: 'programs', meta: {auth: true}, component: ProgramOverview},
    {path: '/program/:id', name: 'program', meta: {auth: true}, component: ProgramDetail},
    {path: '/studentfees', name: 'studentfees', meta: {auth: true}, component: StudentFeeOverview},
    {path: '/studentfee/:id', name: 'studentfee', meta: {auth: true}, component: StudentFeeDetail},
    {path: '/milestones', name: 'milestones', meta: {auth: true}, component: MilestoneOverview},
    {path: '/milestone/:id', name: 'milestone', meta: {auth: true}, component: MilestoneDetail},
    {path: '/students', name: 'students', meta: {auth: true}, component: StudentOverview},
    {path: '/student/:id', name: 'student', meta: {auth: true}, component: StudentDetail},
    {path: '/contracts', name: 'contracts', meta: {auth: true}, component: ContractOverview},
    {path: '/contract/:id', name: 'contract', meta: {auth: true}, component: ContractDetail},
    {path: '/invoices/planned', name: 'planned_invoices', meta: {auth: true}, component: InvoiceOverview},
    {path: '/invoices/numbered', name: 'numbered_invoices', meta: {auth: true}, component: InvoiceOverview},
    {path: '/invoices/creditnote', name: 'creditnote_invoices', meta: {auth: true}, component: InvoiceOverview},
    {path: '/invoice/planned/:id', name: 'planned_invoice', meta: {auth: true}, component: InvoiceDetail},
    {path: '/invoice/numbered/:id', name: 'numbered_invoice', meta: {auth: true}, component: InvoiceDetail},
    {path: '/invoice/creditnote/:id', name: 'creditnote_invoice', meta: {auth: true}, component: InvoiceDetail},
    {path: '/invoicepayments', name: 'invoicepayments', meta: {auth: true}, component: InvoicPaymentOverview},
    {path: '/invoicepayment/:id', name: 'invoicepayment', meta: {auth: true}, component: InvoicePaymentDetail},
    {path: '/scholarshippayments/planned', name: 'planned_scholarshippayments', meta: {auth: true}, component: ScholarshipPaymentOverview},
    {path: '/scholarshippayments/numbered', name: 'numbered_scholarshippayments', meta: {auth: true}, component: ScholarshipPaymentOverview},
    {path: '/scholarshippayment/planned/:id', name: 'planned_scholarshippayment', meta: {auth: true}, component: ScholarshipPaymentDetail},
    {path: '/scholarshippayment/numbered/:id', name: 'numbered_scholarshippayment', meta: {auth: true}, component: ScholarshipPaymentDetail}
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js